type VehicleStatusKey =
  | 'administrativeStatus'
  | 'logisticStatus'
  | 'generalStatus'
  | 'auctionStatus'
  | 'registrationDocumentStatus'
  | 'qualityControlStatus'
  | 'blockingReason'

type Status = Record<VehicleStatusKey, number | null | string>

const defaultStatus: Status = {
  administrativeStatus: '',
  logisticStatus: '',
  generalStatus: '',
  auctionStatus: '',
  registrationDocumentStatus: '',
  qualityControlStatus: '',
  blockingReason: '',
}

const loadingStatus: Status = {
  administrativeStatus: '...',
  logisticStatus: '...',
  generalStatus: '...',
  auctionStatus: '...',
  registrationDocumentStatus: '...',
  qualityControlStatus: '...',
  blockingReason: '...',
}

const errorStatus: Status = {
  administrativeStatus: 'Err',
  logisticStatus: 'Err',
  generalStatus: 'Err',
  auctionStatus: 'Err',
  registrationDocumentStatus: 'Err',
  qualityControlStatus: 'Err',
  blockingReason: 'Err',
}

export type { Status }
export { defaultStatus, loadingStatus, errorStatus }
